// mow-frontend/src/services/publicAlertService.js
import { authenticatedFetch } from './api';

/**
 * Creates a new public alert/news item.
 * @param {object} alertData - { title, message, type }
 */
export const createPublicAlert = (alertData) => {
  return authenticatedFetch('/public-alerts', {
    method: 'POST',
    body: JSON.stringify(alertData),
  });
};

/**
 * Fetches all active public alert/news items.
 */
export const getActivePublicAlerts = () => {
  return authenticatedFetch('/public-alerts');
};

/**
 * Archives a public alert/news item, removing it from the public feed.
 * @param {number} id - The ID of the alert to archive.
 */
export const archivePublicAlert = (id) => {
  return authenticatedFetch(`/public-alerts/${id}/archive`, {
    method: 'PATCH', // Using PATCH as we are updating the status
  });
};

export const updatePublicAlert = async (id, alertData) => {
    // Adjust the endpoint path if your API differs
    const response = await authenticatedFetch(`/public-alerts/${id}`, {
        method: 'PUT', // or 'PATCH' depending on your backend
        body: JSON.stringify(alertData)
    });
    return response;
};